import React from "react"
import { NavItemWrapper } from "./MainNavigation"
import { useIntl } from "react-intl"
import { Paths } from "#/utils/Paths"
import { faqsLabelMessage } from "#/pages/faqs/messages"

export function FaqsNavItem({ onClick }: { onClick: () => void }): JSX.Element {
  const intl = useIntl()

  const handleClick = () => {
    window.open(Paths.FAQS, "_blank")
    onClick()
  }

  return <NavItemWrapper link={Paths.FAQS} button onClick={handleClick} text={intl.formatMessage(faqsLabelMessage)} />
}
